import { render, staticRenderFns } from "./TestUserDashboard.vue?vue&type=template&id=1f3ba959&scoped=true"
import script from "./TestUserDashboard.vue?vue&type=script&lang=js"
export * from "./TestUserDashboard.vue?vue&type=script&lang=js"
import style0 from "./TestUserDashboard.vue?vue&type=style&index=0&id=1f3ba959&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3ba959",
  null
  
)

export default component.exports